/** Default hover / accessibility copy when a chip cannot be removed (e.g. locked contributor). */
export const CHIP_REMOVE_DISABLED_TITLE_DEFAULT = 'Cannot be removed';
